import { lazy, object, array, string } from '@gogame/schemas';

import {
  FACEBOOK,
  GOOGLE_ADS,
  SNAPCHAT,
  REMERGE,
  ADIKTEEV,
  IRONSOURCE,
  TABOOLA,
  MOLOCO,
  TIKTOK,
  BING,
  YOUAPPI,
  APPLOVIN,
  TWITTER,
  DEV,
} from 'scenes/CustomAudiences/constants';

import { validationSchema as adikteevValidationSchema } from './PartnerAudiencesFieldset/Partners/Adikteev/schema';
import { validationSchema as appLovinValidationSchema } from './PartnerAudiencesFieldset/Partners/AppLovin/schema';
import { validationSchema as bingValidationSchema } from './PartnerAudiencesFieldset/Partners/Bing/schema';
import { validationSchema as facebookValidationSchema } from './PartnerAudiencesFieldset/Partners/Facebook/schema';
import { validationSchema as googleAdsValidationSchema } from './PartnerAudiencesFieldset/Partners/GoogleAds/schema';
import { validationSchema as ironsourceValidationSchema } from './PartnerAudiencesFieldset/Partners/IronSource/schema';
import { validationSchema as molocoValidationSchema } from './PartnerAudiencesFieldset/Partners/Moloco/schema';
import { validationSchema as remergeValidationSchema } from './PartnerAudiencesFieldset/Partners/Remerge/schema';
import { validationSchema as snapchatValidationSchema } from './PartnerAudiencesFieldset/Partners/Snapchat/schema';
import { validationSchema as taboolaValidationSchema } from './PartnerAudiencesFieldset/Partners/Taboola/schema';
import { validationSchema as tikTokValidationSchema } from './PartnerAudiencesFieldset/Partners/TikTok/schema';
import { validationSchema as twitterValidationSchema } from './PartnerAudiencesFieldset/Partners/Twitter/schema';
import { validationSchema as youAppiValidationSchema } from './PartnerAudiencesFieldset/Partners/YouAppi/schema';
import { validationSchema as devValidationSchema } from './PartnerAudiencesFieldset/Partners/Dev/schema';
import { NAME, PARENT_AUDIENCE, PARTNER_AUDIENCES, OWNER } from './constants';

const getPartnerValidationSchema = (partner) => {
  switch (partner) {
    case FACEBOOK:
      return facebookValidationSchema;
    case GOOGLE_ADS:
      return googleAdsValidationSchema;
    case SNAPCHAT:
      return snapchatValidationSchema;
    case REMERGE:
      return remergeValidationSchema;
    case ADIKTEEV:
      return adikteevValidationSchema;
    case IRONSOURCE:
      return ironsourceValidationSchema;
    case TABOOLA:
      return taboolaValidationSchema;
    case MOLOCO:
      return molocoValidationSchema;
    case TIKTOK:
      return tikTokValidationSchema;
    case BING:
      return bingValidationSchema;
    case YOUAPPI:
      return youAppiValidationSchema;
    case APPLOVIN:
      return appLovinValidationSchema;
    case TWITTER:
      return twitterValidationSchema;
    case DEV:
      return devValidationSchema;
    default:
      return object();
  }
};

export const validationSchema = object({
  [PARENT_AUDIENCE]: string().required('Audience is required'),
  [OWNER]: string().required('Owner is required'),
  [PARTNER_AUDIENCES]: array(
    lazy((value = {}) => getPartnerValidationSchema(value.partner))
  ).required('Partner Audiences is required'),
});

export const singleAudienceValidationSchema = object({
  [NAME]: string().required('Name is required'),
  [OWNER]: string().required('Owner is required'),
});

export const getDefaultValues = (partner) => {
  return getPartnerValidationSchema(partner).default();
};
